import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, formDataPost, get, patch, post, put } from "helpers/api_helper"
import {
  ADD_TRAINING_MATERIAL,
  DELETE_TRAINING_MATERIAL,
  GET_ALL_TRAINING_MATERIALS,
  GET_TRAINING_MATERIAL_DETAILS,
  UPDATE_TRAINING_MATERIAL,
} from "helpers/url_helper"

export const getAllTrainingMaterials = createAsyncThunk(
  GET_ALL_TRAINING_MATERIALS,
  async payload => {
    const response = await post(GET_ALL_TRAINING_MATERIALS, payload)
    return response
  }
)

export const addTrainingMaterial = createAsyncThunk(
  ADD_TRAINING_MATERIAL,
  async payload => {
    const response = await formDataPost(ADD_TRAINING_MATERIAL, payload)
    return response
  }
)

export const updateTrainingMaterial = createAsyncThunk(
  UPDATE_TRAINING_MATERIAL,
  async payload => {
    const { uuid, data } = payload
    const response = await formDataPost(
      `${UPDATE_TRAINING_MATERIAL}/${uuid}`,
      data
    )
    return response
  }
)

export const getTrainingMaterialDetails = createAsyncThunk(
  GET_TRAINING_MATERIAL_DETAILS + "GET_DETAILS",
  async uuid => {
    const response = await get(`${GET_TRAINING_MATERIAL_DETAILS}/${uuid}`)
    return response
  }
)

export const deleteTrainingMaterial = createAsyncThunk(
  DELETE_TRAINING_MATERIAL + "DELETE",
  async uuid => {
    const response = await del(`${DELETE_TRAINING_MATERIAL}/${uuid}`)
    return response
  }
)
